import React from "react";
import styles from "../styles/campaignNotifications.module.scss";

const formatValue = (value) => {
  if (value == null || value === "") return "—";
  return String(value).replace(/_/g, " ");
};

export default function NotificationReadOnlyMeta({ detail = {} }) {
  const items = [
    { label: "Category", value: formatValue(detail.category) },
    { label: "Notification type", value: formatValue(detail.notification_type) },
    { label: "Message type", value: formatValue(detail.message_type) },
    { label: "Deep link", value: detail.deep_link || "—" },
  ];

  return (
    <div className={styles.metaGrid}>
      {items.map((item) => (
        <div key={item.label} className={styles.metaItem}>
          <span className={styles.metaLabel}>{item.label}</span>
          <span className={styles.metaValue}>{item.value}</span>
        </div>
      ))}
    </div>
  );
}
